export interface ApiState {
    isLoading: boolean;
    error: string;
}

export const IS_LOADING = "IS_LOADING";
export const IS_ERROR = "IS_ERROR";
